import type { UTPlaceResourceType, UTPlaceReservationOriginType } from "@outlook/unified_telemetry";
import { logUsage } from "owa-analytics";
import type { CustomDataMap, UnifiedEvent } from "owa-analytics-types";
import { tryGetGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import getEntryPoint from "./utils/getEntryPoint";
/**
 * Standardized logging for workspaces usage
 *
 * eventName IS A TYPE TO KEEP TRACK OF LOGGED EVENTS IN WORKSPACES
 * MAKE SURE TELEMETRY IS UPDATED IN https://outlookweb.visualstudio.com/MicrosoftPlaces/_wiki/wikis/MicrosoftPlaces.wiki/5908/Logged-Telemetry-Workspaces
 *
 * TODO: REFACTOR LEGACY TELEMETRY TO ALIGN WITH UNIFIED TELEMETRY. WI 180399
 */
export default function logWorkspacesUsage(eventName: WorkspaceEventName, customData: {
    // Preferred to use this if only one placeId is logged
    PlaceId?: string;
    PlaceType?: UTPlaceResourceType;
    // The following is used for search bar.
    SearchBuildingId?: string;
    SearchFloorLabel?: string;
    SearchDateRangeStart?: string;
    SearchDateRangeEnd?: string;
    // Reservation
    ReservationId?: string;
    // Origin
    Origin?: UTPlaceReservationOriginType;
    // Common
    Error?: string;
}, unifiedTelemetry?: UnifiedEvent | undefined): void {
    // go through each map, remove undefined or null properties
    // not checking for falsy value because 0 is a possible value
    const cleanCustomData: CustomDataMap = {};
    /* eslint-disable-next-line owa-custom-rules/forbid-foreach-with-variables-outside-of-function-scope -- (https://aka.ms/OWALintWiki)
     * https://dev.azure.com/outlookweb/Outlook%20Web/_wiki/wikis/Outlook%20Web.wiki/9650/Use-for-const-loop-of-instead-of-forEach
     *	> When using a forEach function call, avoid using variables outside of the scope of the function, use for (const item of array) instead */
    Object.keys(customData).forEach(key => {
        const customDataKey = key as keyof typeof customData;
        if (customData[customDataKey] !== undefined || customData[customDataKey] !== null) {
            cleanCustomData[key] = customData[customDataKey];
        }
    });
    cleanCustomData["entryPoint"] = getEntryPoint();
    const logger = workspaceLoggers[eventName];
    if (logger) {
        logger(cleanCustomData, unifiedTelemetry);
    }
}
// map each eventName to a function that calls logUsage with a literal
const workspaceLoggers: Record<WorkspaceEventName, (data: CustomDataMap, ut?: UnifiedEvent) => void> = {
    PlacesWorkspacesBooking: (data, ut) => logUsage("PlacesWorkspacesBooking", tryGetGlobalSettingsAccountMailboxInfo(), data, {
        unifiedTelemetry: ut,
    }),
};
type WorkspaceEventName = "PlacesWorkspacesBooking";
